import { Outlet } from 'react-router-dom';
import ContentSidebar from '../components/ContentSidebar';

const ContentLayout = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <div className="container mx-auto px-4 md:px-6 lg:px-12 py-8 lg:py-12">
                <div className="flex flex-col-reverse lg:flex-row gap-8 lg:gap-12">
                    {/* Sidebar - Visible on Desktop, Bottom on Mobile */}
                    <div className="lg:w-64 flex-shrink-0">
                        {/* Mobile Menu (Bottom) */}
                        <div className="lg:hidden w-full pt-4 border-t border-gray-100">
                            <div className="font-serif text-xl text-gray-900 mb-4">Menü</div>
                            <ContentSidebar />
                        </div>

                        {/* Desktop Sticky Sidebar */}
                        <div className="hidden lg:block sticky top-24">
                            <ContentSidebar />
                        </div>
                    </div>

                    {/* Main Content Area */}
                    <div className="flex-1 bg-white rounded-xl shadow-sm border border-gray-100 min-h-[500px] overflow-hidden">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentLayout;
